









































































import { Component, Vue, Prop } from 'vue-property-decorator';
import Typography from '@/components/atoms/Typography/Typography.vue';
import { ITransactionDetailData, LoyaltyStatus } from '@/models/performance';
import IconInfo from '@/components/icons/Info.vue';
import ItemPurchaseInfoTransaction, {
  ETypeInfoItem
} from './ItemPurchaseInfoTransaction.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { formatMoney } from '@/utils/moneyFormarter';
import { pluralize } from '@/utils';
import DateUtils from '@/utils/DateUtils';
import PerformanceCustomerCenterService from '@/api/PerformanceCustomerCenterService';
import { ECoinStatus } from '@/models/transaction';
import HTTPStatus from '@/constants/httpStatus';

const WAITING_FOR_STATE_MACHINE = 2500;

@Component<OverviewTransaction>({
  components: {
    Typography,
    ItemPurchaseInfoTransaction,
    IconInfo,
    FilledButton
  }
})
export default class OverviewTransaction extends Vue {
  @Prop() transaction!: ITransactionDetailData;
  service: PerformanceCustomerCenterService = new PerformanceCustomerCenterService();

  ETypeInfoItem = ETypeInfoItem;
  formatMoney = formatMoney;
  DateUtils = DateUtils;

  loadingCancelTransaction = false;
  loadingConfirmPayment = false;

  async showDialogCancelTransaction() {
    const responseDialog = await this.$showConfirmDialog({
      title: 'Are you sure you want to cancel this Transaction?',
      description: `This transaction will be cancelled and the consumer wont receive the coins. You can't roll back this action!`,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Confirm',
      align: 'left'
    });

    if (responseDialog !== 'confirm') return;

    try {
      this.loadingCancelTransaction = true;
      const response = await this.service.cancelTransaction(
        this.transaction.id
      );

      if (!this.hasErrorOnRequest(response)) {
        this.$notification('Transaction canceled!');
      }

      setTimeout(() => {
        this.emitEventUpdatedTransaction();
        this.loadingCancelTransaction = false;
      }, WAITING_FOR_STATE_MACHINE);
    } catch (err) {
      this.loadingCancelTransaction = false;
    }
  }

  async showDialogConfirmPayment() {
    const responseDialog = await this.$showConfirmDialog({
      title: 'Are you sure you want to confirme this Payment?',
      description:
        'The purchase has not been confirmed and may be canceled until the refund policy configured',
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Confirm',
      align: 'left'
    });

    if (responseDialog !== 'confirm') return;

    try {
      this.loadingConfirmPayment = true;

      const response = await this.service.confirmPayment(this.transaction.id);

      if (!this.hasErrorOnRequest(response)) {
        this.$notification('Payment confirmed!');
      }

      setTimeout(() => {
        this.emitEventUpdatedTransaction();
        this.loadingConfirmPayment = false;
      }, WAITING_FOR_STATE_MACHINE);
    } catch (err) {
      this.loadingConfirmPayment = false;
    }
  }

  getLabelCoinsMinted() {
    const { coinsGiven } = this.transaction;
    const coins = coinsGiven / 100;

    return `${coins} ${pluralize(coins, 'coin')} minted`;
  }

  haveRefundPolicyPolicyActive(): boolean {
    const diffDays = this.diffDaysToExpireRefundPolicy();

    return (
      this.transaction.loyaltyStatus === LoyaltyStatus.PENDING && diffDays > 0
    );
  }

  diffDaysToExpireRefundPolicy() {
    const now = DateUtils.formattedDate({
      date: new Date(),
      applyTimezone: true
    });

    const refundPolicyDate = DateUtils.formattedDate({
      date: this.transaction.refundableUntil,
      applyTimezone: true
    });

    return DateUtils.getDifferenceDays(refundPolicyDate, now) * -1;
  }

  formatDaysRemaining() {
    const diffDays = this.diffDaysToExpireRefundPolicy();
    return `${diffDays} day${diffDays > 1 ? 's' : ''} remaining `;
  }

  hasErrorOnRequest(resp: any): boolean {
    const status = resp.status;
    return status !== HTTPStatus.OK && status !== HTTPStatus.CREATED;
  }
  emitEventUpdatedTransaction() {
    this.$emit('updatedTransaction');
  }

  isBtnConfirmPaymentEnabled() {
    if (this.loadingCancelTransaction) {
      return false;
    }

    if (this.transaction.coinsRefundAmount >= this.transaction.coinsAmount) {
      return false;
    }

    return this.transaction.coinsStatus === ECoinStatus.PENDING;
  }

  isBtnCancelEnabled() {
    if (this.loadingConfirmPayment) {
      return false;
    }

    if (this.transaction.coinsStatus === ECoinStatus.ACTIVE) {
      return false;
    }

    if (this.transaction.coinsRefundAmount >= this.transaction.coinsAmount) {
      return false;
    }

    const diffDays = this.diffDaysToExpireRefundPolicy();

    return (
      (this.transaction.coinsStatus === ECoinStatus.READY && diffDays > 0) ||
      this.transaction.coinsStatus === ECoinStatus.PENDING
    );
  }
}
